import { IdsInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const diffuseHostFamilies = (input: { centerId: number; enrollmentIds: number[] }) => {
  const { centerId, enrollmentIds } = input
  return restApiClient
    .url(constructApiUrl(API.centers.diffuseHostFamilies.url, { id: centerId }))
    .post<IdsInput>({ ids: enrollmentIds })
}
